import { upperFirst } from 'lodash';
import * as SectionComponents from './sections';
import * as Sentry from '@sentry/browser';
import { urlFor } from '../lib/sanity';
import {
  useLocale,
  trimDate,
  Product,
  LildogProductPrices,
  Locale,
  Content,
  GlobalConfig,
  Store,
} from '@lilbit/shared';
import SimpleBlockContent from './SimpleBlockContent';
import { useRouter } from 'next/router';
import Image from 'next/image';

const resolveSections = (section) => {
  const SectionType = upperFirst(section._type);

  const localizedSection =
    SectionComponents[SectionType.replace('Localized', '')];
  if (localizedSection) {
    return localizedSection;
  }

  const SectionReference =
    SectionComponents[SectionType.replace('Reference', '')];
  if (SectionReference) {
    return SectionReference;
  }
  console.log('Missing section ', section._type);
  Sentry.captureException(
    new Error(`Error in RenderSections, can't find section ${section}.`)
  );
  // eslint-disable-next-line react/display-name
  return () => null;
};

interface Props {
  mainProduct?: Product;
  mainProductPrices?: LildogProductPrices;
  locale: Locale;
  productTaxRate?: number;
  standardTaxRate?: number;
  products?: Product[];
  sections: Content[];
  isApp?: boolean;
  config?: GlobalConfig;
  setVippsModalOpen?: () => void;
  requiresAuth?: boolean | undefined;
  stores?: Store[];
  reviews?: any;
  basicProductWithPrices?: any
  premiumProductWithPrices?: any;
  familyProductWithPrices?: any;
  forEverCoupon?: any;
}
const RenderSections = (props: Props) => {
  const { sections } = props;
  const router = useRouter();

  const additionalProps = {
    urlFor,
    useLocale,
    trimDate,
    SimpleBlockContent,
  };
  const newsOrDogbreeds = [
    'nyheter',
    'news',
    'hunderaser',
    'dogbreeds',
  ].includes(router.query.category as string);

  if (!sections) {
    Sentry.captureException(
      new Error(
        `Error in RenderSections: Expected sections but no sections present.`
      )
    );
    return <div />;
  }

  return (
    <div
      className={`${
        newsOrDogbreeds &&
        'flex flex-wrap justify-center max-w-7xl mx-auto lg:justify-between'
      }`}
    >
      {sections.map((section) => {
        const SectionComponent = resolveSections(section);
        return (
          <SectionComponent
            {...section}
            {...props}
            {...additionalProps}
            key={section._key}
            siteName="lildog"
          />
        );
      })}
    </div>
  );
};

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
export default RenderSections;
